/**
 * Shared configuration for the Sims 4 storyline visualization.
 * Keep values here when they describe app-level behavior rather than one render branch.
 */
import { activeDataset, getDatasetAuthoringStorageKey } from './data/datasets'

export const ACTIVE_DATASET = activeDataset
export const AUTHORING_STORAGE_KEY = getDatasetAuthoringStorageKey(
  ACTIVE_DATASET
)
export const AUTHORING_LEGACY_STORAGE_KEYS =
  ACTIVE_DATASET.id === 'family-fortune'
    ? ['istoryline_authoring_annotations_v1']
    : []
export const AUTHORING_MATCH_ID = ACTIVE_DATASET.matchId
export const DEFAULT_AUTHORING_LAYER_ID = 'layer_default'
export const AUTHORING_DOWNLOAD_FILENAME = 'Authoring_Annotations.json'

export const STORY_SCRIPT_FILE = ACTIVE_DATASET.storyScriptFile
export const PARTICIPANTS_PATH = ACTIVE_DATASET.participantsPath
export const EVENT_DATA_PATH = ACTIVE_DATASET.eventsPath
export const VIDEO_PATH = ACTIVE_DATASET.videoPath

export const SVG_WIDTH = 5000
export const SVG_HEIGHT = 1080
export const SVG_INITIAL_VIEW_BOX = { x: 0, y: 0, w: 14000, h: 1200 }

export const PLAYER_COLORS = {
  Player1: '#00B8D1',
  Player2: '#ff0000',
  Player3: '#9B8BD6',
  Player4: '#ffd149',
}

export const VIDEO_EVENT_TYPES = [
  'Choice',
  'Death',
  'Family Interaction',
  'System_Sim_Status',
]

export const EVENT_ICON_GENERAL_TYPES = [
  'Relocation',
  'System_Sim_Status',
  'Sleep',
  'Death',
  'Letter',
  'Moving_In',
  'Choice',
]

export const EVENT_ICON_PNG_TYPES = [
  'Relocation',
  'System_Sim_Status',
  'Moving_In',
  'Sell',
]

export const FALLBACK_BAND_COLORS = [
  '#0f766e',
  '#9f1239',
  '#6d28d9',
  '#b45309',
  '#1d4ed8',
]

export const AUTHOR_BAND_MIN_RIBBON_Y = 36
export const AUTHOR_BAND_LANE_SPACING = 56
export const AUTHOR_BAND_STORYLINE_GAP = 130

export const AI_INSIGHT_MAX_BAND_TIME_SPAN = 90000
export const AI_INSIGHT_MAX_BAND_ORDER_SPAN = 45
